<template>
    <u-text-field-solo-rounded v-model="modelValue" v-bind="$attrs" @input="$emit('input', modelValue)">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-text-field-solo-rounded>
</template>

<script>
import UTextFieldSoloRounded from "@/components/publish/styles/forms/u-text-field-solo-rounded.vue";

export default {
    props: {
        value: { type: String, default: null },
    },
    components: {
        UTextFieldSoloRounded,
    },
    data() {
        return {
            modelValue: this.$props.value,
        };
    },
    watch: {
        value() {
            this.modelValue = this.value;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
